(() => {
  function init(root) {
    if (root.dataset.bbReady === 'true') return;
    root.dataset.bbReady = 'true';
    const grid = root.querySelector('[data-bb-collection-theme-grid]');
    const search = root.querySelector('[data-bb-collection-theme-search]');
    const searchClear = root.querySelector('[data-bb-collection-search-clear]');
    const empty = root.querySelector('[data-bb-collection-theme-empty]');
    const reset = root.querySelector('[data-bb-collection-reset]');
    const showMore = root.querySelector('[data-bb-collection-show-more]');
    const totalCount = root.querySelector('[data-bb-theme-count]');
    const visibleCount = root.querySelector('[data-bb-visible-theme-count]');
    const startingPrice = root.dataset.bbStartingPrice || '3.000 TL';
    const pageSize = 16;
    let category = 'all';
    let limit = pageSize;
    const fandomPattern = /^(spider-man|batman|avengers|iron-man|deadpool|mini-(?:spider-man|avengers|batman)|pokemon|pikachu|ash-ve-pikachu|charmander|minion)/;

    const classify = (card) => {
      const values = new Set();
      const theme = card.dataset.bbTheme || '';
      const previous = card.dataset.templateCategory || '';
      if (card.hasAttribute('data-photo-slot') || previous === 'fotograf') values.add('fotografli');
      if (previous === 'cocuk' || previous === 'hayvan' || fandomPattern.test(theme)) values.add('cocuk-karakter');
      if (previous === 'ozel-gun') values.add('ozel-gun');
      if (previous === 'meslek') values.add('meslek-hobi');
      if (previous === 'spor' || /(?:futbol|football|motorcycle|racing|yarış|oyun|game)/.test(`${theme} ${card.dataset.templateSearch || ''}`)) values.add('spor-oyun');
      if (!values.size) values.add('ozel-gun');
      card.dataset.templateCategories = [...values].join(' ');
    };

    const sourceButtons = [...grid.querySelectorAll('[data-bb-theme]')];
    const themeCards = [];
    if (totalCount) totalCount.textContent = String(sourceButtons.length);

    sourceButtons.forEach((button) => {
      const link = document.createElement('a');
      [...button.attributes].forEach((attribute) => {
        if (attribute.name !== 'type') link.setAttribute(attribute.name, attribute.value);
      });
      link.href = `/pages/kendi-pastani-tasarla?bb_theme=${encodeURIComponent(button.dataset.bbTheme)}`;
      link.setAttribute('aria-label', `${button.dataset.themeLabel || 'Baskılı tema'} ile tasarlamaya başla`);
      link.innerHTML = button.innerHTML;

      const wrapper = document.createElement('article');
      wrapper.className = 'bb-template-card-wrap';
      button.replaceWith(wrapper);
      wrapper.appendChild(link);
      classify(link);
      themeCards.push(link);

      const cardCopy = link.querySelector(':scope > span');
      if (cardCopy) {
        const categoryLabel = document.createElement('span');
        categoryLabel.className = 'bb-card-category';
        const categories = link.dataset.templateCategories || '';
        categoryLabel.textContent = categories.includes('cocuk-karakter') ? 'Çocuk' : categories.includes('spor-oyun') ? 'Spor' : categories.includes('fotografli') ? 'Fotoğraflı' : categories.includes('meslek-hobi') ? 'Meslek & Hobi' : 'Özel Gün';
        cardCopy.prepend(categoryLabel);
        if (link.hasAttribute('data-photo-slot')) {
          const feature = document.createElement('small');
          feature.className = 'bb-template-card__feature';
          feature.textContent = 'Kendi fotoğrafınızı ekleyin';
          cardCopy.appendChild(feature);
        }
        const price = document.createElement('small');
        price.className = 'bb-template-card__price';
        price.textContent = `10 kişilik ${startingPrice}’den başlayan`;
        cardCopy.appendChild(price);
        const cta = document.createElement('span');
        cta.className = 'bb-template-card__cta';
        cta.textContent = 'Sipariş Ver';
        cardCopy.appendChild(cta);
      }

      const media = link.querySelector(':scope > i');
      const image = media?.querySelector(':scope > img');
      if (!media || !image) return;
      media.classList.add('bb-template-card__media');
      const searchTerms = `${link.dataset.templateSearch || ''} ${link.dataset.themeLabel || ''}`.toLocaleLowerCase('tr-TR');
      media.dataset.studioTone = /(?:romantik|aşk|ask|çiçek|cicek|gül|gul|prenses|balerin|düğün|dugun|nişan|nisan|anne|fotoğraf|fotograf)/.test(searchTerms) ? 'salon' : 'stone';
      image.classList.add('bb-template-card__flat');
      const threeImage = document.createElement('img');
      threeImage.className = 'bb-template-card__3d';
      const localSeed = root.dataset.bbThreeImageSeed || '';
      const source = localSeed
        ? localSeed.replace('bb-theme-3d-avengers.png', `bb-theme-3d-${encodeURIComponent(link.dataset.bbTheme)}.png`)
        : `/apps/cake-designer/templates/3d/bb-theme-3d-${encodeURIComponent(link.dataset.bbTheme)}.png?v=20260906-studio-6`;
      threeImage.alt = `${link.dataset.themeLabel || 'Baskılı tema'} pasta görünümü`;
      threeImage.width = 640;
      threeImage.height = 640;
      threeImage.loading = themeCards.length <= pageSize ? 'eager' : 'lazy';
      if (themeCards.length <= pageSize) threeImage.fetchPriority = 'high';
      threeImage.decoding = 'async';

      const viewToggle = document.createElement('button');
      viewToggle.type = 'button';
      viewToggle.className = 'bb-template-card__view-toggle';
      viewToggle.setAttribute('aria-pressed', 'false');
      viewToggle.setAttribute('aria-label', `${link.dataset.themeLabel || 'Tema'} tasarım görselini göster`);
      viewToggle.textContent = 'Tasarımı göster';
      const loadThreeDimensionalImage = () => {
        if (threeImage.getAttribute('src')) return;
        threeImage.src = source;
      };
      threeImage.addEventListener('load', () => {
        if (threeImage.naturalWidth > 0) media.classList.add('has-3d');
      }, { once: true });
      threeImage.addEventListener('error', () => viewToggle.remove(), { once: true });
      media.appendChild(threeImage);

      viewToggle.addEventListener('click', () => {
        loadThreeDimensionalImage();
        const designIsVisible = !media.classList.contains('is-design');
        media.classList.toggle('is-design', designIsVisible);
        viewToggle.setAttribute('aria-pressed', String(designIsVisible));
        viewToggle.setAttribute('aria-label', `${link.dataset.themeLabel || 'Tema'} ${designIsVisible ? 'pasta görünümünü' : 'tasarım görselini'} göster`);
        viewToggle.textContent = designIsVisible ? 'Pasta görünümü' : 'Tasarımı göster';
      });
      wrapper.appendChild(viewToggle);
      loadThreeDimensionalImage();
    });

    const filter = () => {
      const query = (search.value || '').trim().toLocaleLowerCase('tr-TR');
      const matches = themeCards.filter((card) => {
        const categoryMatch = category === 'all' || (card.dataset.templateCategories || '').split(' ').includes(category);
        const queryMatch = !query || (card.dataset.templateSearch || '').toLocaleLowerCase('tr-TR').includes(query);
        return categoryMatch && queryMatch;
      });
      themeCards.forEach((card) => { card.closest('.bb-template-card-wrap').hidden = true; });
      matches.slice(0, limit).forEach((card) => { card.closest('.bb-template-card-wrap').hidden = false; });
      const shown = Math.min(matches.length, limit);
      if (visibleCount) visibleCount.textContent = String(shown);
      if (totalCount) totalCount.textContent = String(matches.length);
      empty.hidden = matches.length > 0;
      showMore.parentElement.hidden = shown >= matches.length;
      if (shown < matches.length) showMore.textContent = `${Math.min(pageSize, matches.length - shown)} tasarım daha göster`;
      searchClear.hidden = !query;
    };

    const clearFilters = () => {
      search.value = '';
      category = 'all';
      limit = pageSize;
      root.querySelectorAll('[data-bb-collection-theme-category]').forEach((item) => {
        const active = item.dataset.bbCollectionThemeCategory === 'all';
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      filter();
      search.focus();
    };

    search.addEventListener('input', () => { limit = pageSize; filter(); });
    searchClear.addEventListener('click', () => { search.value = ''; limit = pageSize; filter(); search.focus(); });
    reset.addEventListener('click', clearFilters);
    showMore.addEventListener('click', () => { limit += pageSize; filter(); });
    root.querySelectorAll('[data-bb-collection-theme-category]').forEach((button) => {
      button.addEventListener('click', () => {
        category = button.dataset.bbCollectionThemeCategory;
        limit = pageSize;
        root.querySelectorAll('[data-bb-collection-theme-category]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        filter();
      });
    });
    filter();
  }

  const boot = (scope = document) => scope.querySelectorAll('[data-bb-theme-collection]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
